/**
 * cart-discount.js
 * ─────────────────────────────────────────────────────────────────
 * Discount code input, coupon popup, applied-code display for the
 * cart drawer and coupons popup.
 * Depends on: cart-shared.js  (isWidgetEnabled, plumGetSharedCart,
 *                               plumRefreshCart)
 * ─────────────────────────────────────────────────────────────────
 */
(function () {
  if (!isWidgetEnabled('discount_box')) return;

  const CHECKMARK_SVG   = '<svg viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3"/></svg>';
  const FREE_GIFT_CODES = ['PLUMFIRST', 'FREEGIFT', 'ONLY4U' , 'FREESET', 'FIRST100', 'Tumbler1000', 'TRI10'];

  // ─── Helpers ─────────────────────────────────────────────────────────────

  function plumIsFreeGift(code) {
    return FREE_GIFT_CODES.some(function (c) {
      return c.toLowerCase() === code.toLowerCase();
    });
  }

  function debounce(fn, delay) {
    let timer;
    return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
  }

  function plumGetCart(callback) {
    window.plumGetSharedCart(callback);
  }

  // ─── Message elements ─────────────────────────────────────────────────────
  // Each input gets its own dedicated message element, anchored after its row.

  function plumGetOrCreateMessage(inputId, msgId) {
    const input = document.getElementById(inputId);
    if (!input) return null;

    let msg = document.getElementById(msgId);
    if (!msg) {
      msg            = document.createElement('div');
      msg.id         = msgId;
      msg.className  = 'cart-offer-box__message';
      msg.style.display = 'none';
    }

    const inputRow = input.closest('.cart-offer-box__input-row') || input.parentNode;
    if (inputRow && inputRow.nextSibling !== msg) {
      inputRow.parentNode.insertBefore(msg, inputRow.nextSibling);
    }
    return msg;
  }

  function plumDrawerMsg() {
    return plumGetOrCreateMessage('CartDrawer-Discount', 'DiscountMessage');
  }

  function plumPopupMsg() {
    return plumGetOrCreateMessage('CouponsPopup-Discount', 'CouponsPopup-DiscountMessage');
  }

  var plumMsgTimers = {};

  function plumSetMessage(el, text, type) {
    if (!el) return;

    var timerId = el.id || el._plumTimerKey;
    if (timerId && plumMsgTimers[timerId]) {
      clearTimeout(plumMsgTimers[timerId]);
      delete plumMsgTimers[timerId];
    }

    el.textContent = text;
    el.className   = 'cart-offer-box__message' + (type ? ' ' + type : '');
    el.style.display = text ? 'block' : 'none';

    if (!text) return;

    // Clear the associated input
    var inputId = el.id === 'DiscountMessage'
      ? 'CartDrawer-Discount'
      : el.id === 'CouponsPopup-DiscountMessage'
        ? 'CouponsPopup-Discount'
        : null;
    if (inputId) {
      var input = document.getElementById(inputId);
      if (input) input.value = '';
    }

    var key = el.id || (el._plumTimerKey = '_plum_' + Date.now());
    plumMsgTimers[key] = setTimeout(function () {
      el.textContent   = '';
      el.className     = 'cart-offer-box__message';
      el.style.display = 'none';
      delete plumMsgTimers[key];
    }, 5000);
  }

  // ─── Popup open / close ───────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    if (e.target.closest('#ViewAllCoupons'))       plumOpenPopup();
    if (e.target.closest('.coupons-popup__close')) plumClosePopup();
    if (e.target.closest('.coupons-popup__overlay')) plumClosePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') plumClosePopup();
  });

  function plumOpenPopup() {
    const popup = document.getElementById('CouponsPopup');
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    plumSyncPopupState();
    plumPopupMsg(); // anchor message element
  }

  function plumClosePopup() {
    const popup = document.getElementById('CouponsPopup');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ─── Delegated clicks ─────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {

    // Drawer apply
    if (e.target.closest('#ApplyDiscount')) {
      const input = document.getElementById('CartDrawer-Discount');
      const btn   = document.getElementById('ApplyDiscount');
      const msg   = plumDrawerMsg();
      const code  = input?.value.trim();
      if (!code) { plumSetMessage(msg, 'Please enter a discount code.', 'error'); return; }
      plumApplyDiscount(code, btn, msg, input);
      return;
    }

    // Popup apply
    if (e.target.closest('#CouponsPopup-Apply')) {
      const input = document.getElementById('CouponsPopup-Discount');
      const btn   = document.getElementById('CouponsPopup-Apply');
      const msg   = plumPopupMsg();
      const code  = input?.value.trim();
      if (!code) { plumSetMessage(msg, 'Please enter a discount code.', 'error'); return; }
      plumApplyDiscount(code, btn, msg, input);
      return;
    }

    // Coupon card apply buttons
    const cardBtn = e.target.closest('.coupon-card__apply-btn');
    if (cardBtn && !cardBtn.classList.contains('is-applied')) {
      const code = cardBtn.dataset.code;
      if (code) plumApplyDiscount(code, cardBtn, plumPopupMsg(), null);
      return;
    }

    // Copy coupon code
    const copyCodeBtn = e.target.closest('.coupon-copy-code-cart');
    if (copyCodeBtn) {
      const code =
        copyCodeBtn.dataset.code ||
        copyCodeBtn.querySelector('.copy_code')?.textContent.trim();

      if (!code) return;

      navigator.clipboard.writeText(code).then(function () {
        const textEl = copyCodeBtn.querySelector('.copy_code');
        const originalText = textEl ? textEl.textContent : '';

        if (textEl) textEl.textContent = 'Copied!';

        setTimeout(function () {
          if (textEl) textEl.textContent = originalText;
        }, 1500);
      });

      return;
    }
    
    // Remove buttons
    const removeBtn = e.target.closest('.cart-offer-box__remove-btn, .tag-remove');
    if (removeBtn) {
      const code    = removeBtn.dataset.code;
      const isPopup = !!removeBtn.closest('#CouponsPopup');
      const msg     = isPopup ? plumPopupMsg() : plumDrawerMsg();
      const btn     = isPopup
        ? document.getElementById('CouponsPopup-Apply')
        : document.getElementById('ApplyDiscount');

      plumGetCart(function (cart) {
        const remaining = plumGetAppliedCodes(cart)
          .filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); })
          .join(',');

        plumSendDiscount(remaining, btn, msg, function (updatedCart) {
          const codes = plumGetAppliedCodes(updatedCart);
          plumRenderApplied(updatedCart, codes);
          plumSyncPopupState(updatedCart, codes);
          plumSetMessage(msg, '"' + code + '" removed.', 'success');
          window.plumRefreshCart(updatedCart);
        });
      });
    }
  });

  // ─── Apply ────────────────────────────────────────────────────────────────

  function plumApplyDiscount(code, btn, msg, input) {
     if (code.toUpperCase() === 'FIRST100') {
        if (msg) plumSetMessage(
          msg,
          "FIRST100 can't be applied in cart. Please apply them at checkout to unlock the offer.",
          'info'
        );
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Apply';
        }
        return;
      }
     if (code.toUpperCase() === 'TRI10') {
        if (msg) plumSetMessage(
          msg,
          "This offer can be availed at checkout. Proceed to checkout to apply your coupon.",
          'info'
        );
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Apply';
        }
        return;
      }
    if (plumIsFreeGift(code)) {
      if (msg) plumSetMessage(
        msg,
        "Free gift coupons can't be applied in cart. Please apply them at checkout to unlock the offer.",
        'info'
      );
      if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Applying...'; }

    plumGetCart(function (cart) {
      const existing = plumGetAppliedCodes(cart);
      const already  = existing.some(function (c) {
        return c.toLowerCase() === code.toLowerCase();
      });

      if (already) {
        if (msg) plumSetMessage(msg, '"' + code + '" is already applied.', 'error');
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
        return;
      }

      plumSendDiscount(existing.concat(code).join(','), btn, msg, function (updatedCart) {
        const appliedCodes = plumGetAppliedCodes(updatedCart);
        const accepted     = appliedCodes.some(function (c) {
          return c.toLowerCase() === code.toLowerCase();
        });

        if (accepted) {
          plumRenderApplied(updatedCart, appliedCodes);
          plumSyncPopupState(updatedCart, appliedCodes);
          if (msg)   plumSetMessage(msg, '', '');
          if (input) input.value = '';
          window.plumRefreshCart(updatedCart);
        } else {
          if (msg) plumSetMessage(msg, '"' + code + '"isn\'t applicable to your current cart. Please check the offer details and try again.', 'error');
        }

        if (btn) {
          btn.disabled  = false;
          btn.textContent = btn.closest('.coupon-card')
            ? (accepted ? 'Applied' : 'Apply')
            : 'Apply';
        }
      });
    });
  }

  // ─── Render: drawer applied rows ─────────────────────────────────────────

  function plumRenderApplied(cart, codes) {
    const wrapper = document.getElementById('AppliedDiscounts');
    const form    = document.getElementById('DiscountForm');
    if (!wrapper) return;

    if (!codes.length) {
      wrapper.style.display = 'none';
      wrapper.innerHTML     = '';
      if (form) form.style.display = 'flex';
      return;
    }

    wrapper.innerHTML = codes.map(function (code) {
      const app     = (cart.cart_level_discount_applications || []).find(function (d) {
        return d.title?.toUpperCase() === code;
      });
      const savings = app?.total_allocated_amount ? plumFormatMoney(app.total_allocated_amount) : null;

      return `
      <div class="cart-offer-box__applied-row">
        <div class="cart-offer-box__applied-left">
          <span class="cart-offer-box__applied-icon">${CHECKMARK_SVG}</span>
          <div class="cart-offer-box__applied-content">
            <div class="cart-offer-box__applied-text">
              ${savings ? `You saved ${savings} with` : 'Coupon applied with'}
              <strong class="cart-offer-box__applied-code">&#8216;${code}&#8217;</strong>
            </div>
          </div>
        </div>
        <button type="button" class="cart-offer-box__remove-btn" data-code="${code}">
          Remove
        </button>
      </div>`;
    }).join('');

    wrapper.style.display = 'flex';
    if (form) form.style.display = 'none';
  }

  // ─── Sync: popup tag + card states ───────────────────────────────────────

  function plumSyncPopupState(cart, codes) {
    if (!cart || !codes) {
      plumGetCart(function (c) { plumSyncPopupState(c, plumGetAppliedCodes(c)); });
      return;
    }

    const tagWrapper = document.getElementById('CouponsPopup-Applied');
    if (tagWrapper) {
      if (codes.length) {
        tagWrapper.style.display = 'flex';
        tagWrapper.innerHTML = codes.map(function (code) {
          return '<span class="tag-code">&#x1F3F7; ' + code +
            '<button type="button" class="tag-remove" data-code="' + code + '">&#x2715;</button>' +
            '</span>';
        }).join('');
      } else {
        tagWrapper.style.display = 'none';
        tagWrapper.innerHTML     = '';
      }
    }

    document.querySelectorAll('.coupon-card__apply-btn').forEach(function (btn) {
      const isApplied = codes.includes(btn.dataset.code?.toUpperCase());
      btn.textContent = isApplied ? 'Applied' : 'Apply';
      btn.classList.toggle('is-applied', isApplied);
      btn.disabled = isApplied;
    });
  }

  // ─── Low-level helpers ────────────────────────────────────────────────────

  function plumSendDiscount(discountString, btn, msg, onSuccess) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ discount: discountString })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (onSuccess) onSuccess(cart); })
      .catch(function () {
        if (msg) plumSetMessage(msg, 'Something went wrong. Please try again.', 'error');
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      });
  }

  function plumGetAppliedCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable === true && d.code; })
      .map(function (d)    { return d.code.toUpperCase(); });
  }

  function plumFormatMoney(cents) {
    return window.Shopify?.currency?.active
      ? (cents / 100).toLocaleString('en-IN', {
          style:    'currency',
          currency: window.Shopify.currency.active
        })
      : '₹' + (cents / 100).toFixed(0);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function plumDiscountInit() {
    plumDrawerMsg();
    plumPopupMsg();
    plumGetCart(function (cart) {
      const codes = plumGetAppliedCodes(cart);
      plumRenderApplied(cart, codes);
      plumSyncPopupState(cart, codes);
    });
  }

  const plumObserverCallback = debounce(function () {
    const form = document.getElementById('DiscountForm');
    if (!form || form.style.display === 'none') return;
    plumDrawerMsg();
    plumPopupMsg();
    plumGetCart(function (cart) {
      const codes = plumGetAppliedCodes(cart);
      if (codes.length) {
        plumRenderApplied(cart, codes);
        plumSyncPopupState(cart, codes);
      }
    });
  }, 300);

  document.addEventListener('DOMContentLoaded', function () {
    plumDiscountInit();
    const cartDrawer = document.querySelector('.cart-drawer, #cart-drawer') || document.body;
    new MutationObserver(plumObserverCallback).observe(cartDrawer, { childList: true, subtree: true });
  });

  document.documentElement.addEventListener('cart:updated', plumDiscountInit);
})();
